"use strict";

exports.__esModule = true;
exports.galleryParser = exports.extractWidthHeight = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _components = require("@bodhi-project/components");

var _typography = require("@bodhi-project/typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstract stuff

// import { css } from 'glamor';
// import moment from 'moment';

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
// ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Imports
// ------------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
var Fragment = _react2.default.Fragment; // eslint-disable-line import/no-extraneous-dependencies
// import PropTypes from 'prop-types';

var Paragraph = _typography.Elements.Paragraph;

// ------------------------------------------------------------------------------
// -------------------------------------------------------------------- Component
// ------------------------------------------------------------------------------
/** check if json */

var isJson = function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

/** extractWidthHeight */
var extractWidthHeight = exports.extractWidthHeight = function extractWidthHeight(imageName) {
  var returnDimensions = { width: 900, height: 900 };
  if (imageName.includes("_") && imageName.includes("X")) {
    var xy = _lodash2.default.split(_lodash2.default.split(_lodash2.default.split(imageName, "_")[1], ".")[0], "X");
    returnDimensions = {
      width: parseInt(xy[0], 10),
      height: parseInt(xy[1], 10)
    };
  }
  return returnDimensions;
};

var defaultOptions = { indent: -20 };
var dOpt = defaultOptions;

var defaultType = {};
var dT = defaultType;

/** galleryParser */
var galleryParser = exports.galleryParser = function galleryParser(gallery) {
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : dOpt;
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : dT;

  var photoGallery = gallery;

  var soloImage = null;
  var style = { border: 0 };

  if (gallery.length % 2 !== 0) {
    soloImage = gallery.pop();
  }

  if (!_lodash2.default.isNull(soloImage)) {
    if (!_lodash2.default.isNull(soloImage.alt)) {
      if (isJson(soloImage.alt)) {
        var probableObject = JSON.parse(soloImage.alt);
        if (_lodash2.default.isObject(probableObject)) {
          style = _lodash2.default.merge(style, probableObject);
        }
      }
    }
  }

  return _react2.default.createElement(
    "div",
    { className: "mask-p" },
    _react2.default.createElement(_components.Images, { photos: photoGallery, columns: 2, loader: "gradient" }),
    soloImage && _react2.default.createElement(_components.Image, {
      src: soloImage.src,
      rawWidth: soloImage.width,
      rawHeight: soloImage.height,
      loader: "gradient",
      style: style
    })
  );
};

galleryParser.propTypes = process.env.NODE_ENV !== "production" ? {} : {};


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/markdown-to-react/lib/parsers/galleryParser.js
// module id = 437
// module chunks = 168707334958949